import { Component, Input } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { QueueDataService } from '../services/queue-data.service';
import { tap } from 'rxjs/operators';
import { Connection } from '../models/connection';
import { ExternalEditGridComponent } from 'src/app/core/external-edit-grid.component';
import { Queue } from '../models/queue';

@Component({
  selector: 'app-queues',
  templateUrl: './queues.component.html',
  styleUrls: ['./queues.component.scss']
})
export class QueuesComponent extends ExternalEditGridComponent<Queue> {

  public gridState: State = {
    sort: [
      {
        field: "Name",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 10
  };
    
  constructor(
    private dataService: QueueDataService
  ) {
    super(Queue);
  }

  @Input() public connection: Connection;

  ngOnInit() {
    super.ngOnInit();
  }

  protected refresh() {
    this.view = this.dataService
      .get(this.gridState, `&$filter=connectionId eq ${this.connection.Id}`)
      .pipe(tap(() => (this.loading = false)));
  }

  public saveHandler(queue: Queue) {
  }  

  public removeHandler({ dataItem }) {
  }
}
